export default __webpack_public_path__ + "static/media/En Garde.9ce88de9.png";